// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { readNotification } from '../../../apis/member'
import { readNotificationActions } from '../../actionCreators/notifications/readNotificationActions';
import { RootAction } from '../../rootActionCreator';

const outputActions = {
  success: readNotificationActions.success,
  failure: readNotificationActions.failure
};

type RequestActionTypes = ActionType<typeof readNotificationActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const readNotificationEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(readNotificationActions.request)
    ),
    switchMap(async (action: RequestActionTypes) => {
      const {
        id,
        success
      } = action.payload;

      return readNotification(id)
        .then(() => {
          success();
          return outputActions.success({ id });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return outputActions.failure({ error });
        });
    })
  );
};
